<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import "@/serve/api/time.js";
export default {
  name: "App",
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          if (that.screenWidth < 750) {
            // location = "https://mobile.tuoluo.cn";
          } else {
            var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
            var rem = that.screenWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
            document.getElementsByTagName("html")[0].style.fontSize =
              rem + "px";
            that.timer = false;
          }
        }, 400);
      }
    },
  },
  data(){
    return{
      isRouterAlive:true
    }
  },
  provide(){
    return{
      reload:this.reload
    }
  },
  methods:{
    reload(){
      this.isRouterAlive = false
      this.$nextTick(()=>{
        this.isRouterAlive = true
      })
    }
  }
};
</script>

<style lang="scss">
@import "/style/common.css";
@import "/style/elementuiSty.css";
@import "/style/basics.css";
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0064ff !important;
}
// 单选框
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0064ff !important;
  border-color: #0064ff !important;
}
.el-checkbox__input {
  border-color: #98a7b9 !important;
}

.el-checkbox__label {
  color: #98a7b9;
}
// 修改弹框message大小
.el-message {
  width: fit-content;
  min-width: 2rem;
  min-height: 0.56rem;
  top: 1rem !important;
}
.el-message .el-icon-warning,
.el-message__icon {
  font-size: 0.36rem;
}

// 消息图标
.messageRadius {
  width: 0.28rem;
  height: 0.28rem;
  background: linear-gradient(
    180deg,
    rgba(49, 130, 255, 1) 0%,
    rgba(0, 100, 255, 1) 100%
  );
  border-radius: 50%;
  img {
    width: 0.14rem;
    height: 0.14rem;
  }
}
.el-table__header-wrapper,
.has-gutter,
.el-table th,
.el-table th,
.el-table tr {
  background: #f7f9fc;
}
.shortChainTable .el-table__header-wrapper,
.has-gutter,
.el-table th,
.el-table th,
.el-table tr {
  background: #fff;
}
.el-table__row--striped {
  background: #fff !important;
}
.el-textarea__inner {
  border: none;
  padding: 0;
}
.previewFillLabelTxt .el-textarea__inner {
  background: rgba(247, 249, 252, 1);
}
.title .el-table__row {
  background: #fff !important;
}
.title .el-table__row--striped {
  background: #f4f6f9 !important;
}
.title tr {
  background: #fff !important;
}
.guide .el-dialog__wrapper .el-dialog .el-dialog__header {
  display: none;
  padding: 0 !important;
}
.guide .el-dialog__wrapper .el-dialog .el-dialog__body {
  padding: 0;
}
.guide .el-dialog__wrapper .el-dialog {
  padding-bottom: 0.3rem;
}
.vjs-custom-skin > .video-js .vjs-big-play-button {
  border: none !important;
}
.vjs-current-,
.vjs-time-divider,
.vjs-current-time,
.vjs-duration {
  display: none !important;
}
.previewFillLabelInfo .el-input__inner,.sendInfoInputsItem input {
  border: none !important;
  background: rgba(247, 249, 252, 1);
  height: 0.36rem;
}
.previewFillLabelInfo .sendInput .el-input__inner,
.previewFillLabelInfo .sendInput .el-input__inner {
  padding: 0;
}



.el-progress{
  width:100%;		
}
.el-progress__text{
  color: #fff;
  font-size: 14px;
}
.el-progress-bar__outer{
  height: 12px!important;
  border: 1px solid #78335f;
  background-color:transparent;
}

/* 渐变进度条 */
.el-bg-inner-running .el-progress-bar__inner{
  background-color: unset;
  background-image: linear-gradient(to right, #3587d8 , #6855ff);
}
.el-bg-inner-error .el-progress-bar__inner{
  background-image: linear-gradient(to right, #3587d8 , #fb3a7e);
}
.el-bg-inner-done .el-progress-bar__inner{
  background-image: linear-gradient(to right, #3587d8 , #53ff54);
}
</style>



// WEBPACK FOOTER //
// src/App.vue